// extracted by mini-css-extract-plugin
export default {"OrderLog":"OrderLog_OrderLog__dANRV","loading":"OrderLog_loading__XmsMY","pagination":"OrderLog_pagination__OmHzG"};